import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Loader from './Components/Loader.jsx'; 
import ScrollToTop from './Components/ScrollToTop.jsx';
import AppointmentHeader from './Components/AppointmentHeader';
import Header from './Components/pages/Header.jsx';
import Footer from './Components/pages/Footer.jsx';
import HomePage from './Components/pages/Home.jsx'; // Renamed to avoid conflict
import WhatsAppButton from './Components/WhatsAppButton.jsx';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Auth from './Components/pages/Auth.jsx';
import AdminDashboard from './Components/pages/AdminDashboard.jsx';
import AppointmentForm from './Components/pages/AppointmentForm.jsx';
import About from './Components/pages/About.jsx';
import MedicalPanel from './Components/pages/MedicalPanel.jsx';
import Blog from './Components/pages/Blog.jsx';
import OurServices from './Components/pages/Services.jsx';
import Popup from './Components/pages/Popup.jsx';
import './App.css';

const Home = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [intervals, setIntervals] = useState([5000, 30000, 60000, 1200000, 1500000]); // Popup intervals in milliseconds
    const [currentIntervalIndex, setCurrentIntervalIndex] = useState(0);

    useEffect(() => {
        const showPopupInterval = setInterval(() => {
            if (currentIntervalIndex < intervals.length) {
                setShowPopup(true);
                setCurrentIntervalIndex(currentIntervalIndex + 1);
            } else {
                clearInterval(showPopupInterval); // Stop if all intervals are used
            }
        }, intervals[currentIntervalIndex]);

        return () => clearInterval(showPopupInterval); // Cleanup interval on unmount
    }, [currentIntervalIndex, intervals]);

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <HomePage />
            {showPopup && <Popup onClose={handleClosePopup} />}
        </div>
    );
};

function App() {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check session storage for the loader
        if (!sessionStorage.getItem('loaderShown')) {
            setLoading(true);
            sessionStorage.setItem('loaderShown', 'true'); // Mark as shown
        }

        const handleLoad = () => {
            setLoading(false);
        };

        window.addEventListener('load', handleLoad);

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, []);

    const handleLinkClick = () => {
        setLoading(true); // Show loader when navigating to another page
    };

    return (
        <Router>
            {loading && <Loader />} {/* Show loader conditionally */}
            <div>
                <AppointmentHeader />
            </div>
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<OurServices />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/login" element={<Auth />} />
                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path="/appointment" element={<AppointmentForm />} />
                <Route path="/medical-panel" element={<MedicalPanel />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/contact-us" element={<AppointmentForm />} />
            </Routes>
            <Footer />
            <WhatsAppButton /> {/* Add the WhatsApp button */}
        </Router>
    );
}

export default App;
